/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListCreateVariableMessage } from '../../models/api-response-list-create-variable-message';

export interface GetVariablesContextValues$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  contactRef: string;
  phoneCompanyRef: string;
}

export function getVariablesContextValues(http: HttpClient, rootUrl: string, params: GetVariablesContextValues$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListCreateVariableMessage>> {
  const rb = new RequestBuilder(rootUrl, getVariablesContextValues.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('contactRef', params.contactRef, {});
    rb.query('phoneCompanyRef', params.phoneCompanyRef, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListCreateVariableMessage>;
    })
  );
}

getVariablesContextValues.PATH = '/v1/api/ui/message/context-variables';
